<mat-form-field appearance="outline" [formGroup]="formGroup" style="margin-bottom: -1.25em; width: 100%;">
    <mat-label>{{config.label}}</mat-label>
    <input matInput [required]="requerido" [matDatepicker]="picker1"
           [placeholder]="config.placeholder || ''"
           [formControl]="controle" />
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
</mat-form-field>
